import fs from 'fs'
import path from 'path'
import figlet from 'figlet'
import * as jsonc from 'jsonc-parser'

const init = (header?: string) => {
  console.log('-----------------------------------------------')
  console.log(header)
  console.log('-----------------------------------------------')
  console.log('*********** @korautils/alias-fixer ************')
  console.log('-----------------------------------------------')
  // console.log('-----------------------------------------------')
  console.log('🔍 Finding tsconfig file...')
  // console.log('-----------------------------------------------')
  const tsconfig = getTsConfig()
  // valido si tiene paths configurados, si no pues no hay nada que hacer...
  if (!checkPaths(tsconfig)) {
    console.log(
      'ERROR: No se encontró el archivo tsconfig.json o no se encontró una configuración válida'
    )
    console.log('Se finaliza la operación.')
    return
  }

  const dir = path.resolve(process.cwd(), getArgument('--dir', './'))
  const types = getArgument('--types', 'ts,tsx,jsx,js').split(',')
  const exclude = getProp(tsconfig, 'exclude', ['node_modules'])
  console.log('🗂️  dir:', dir)
  console.log('⚪️ types:', types)
  console.log('🚫 exclude:', exclude)
  const files = listFilesByTypes(dir, types, exclude)
  // console.log(files)
  replaceImportsWithAliases(files, tsconfig)
  console.log('-----------------------------------------------')
  console.log('✅ Process completed successfully.')
  console.log('-----------------------------------------------')
}

/**
 * Replaces relative imports in files with aliases from tsconfig.
 * @param {string[]} files - List of file paths to process.
 * @param {any} tsconfig - The loaded tsconfig.json object.
 */
function replaceImportsWithAliases(files: string[], tsconfig: any) {
  const paths = tsconfig.compilerOptions?.paths || {}
  const dir = path.resolve(
    process.cwd(),
    tsconfig.compilerOptions?.baseUrl || './'
  )

  const computedPaths: { alias: string; folders: string[] }[] = []
  for (const alias in paths) {
    if (Object.prototype.hasOwnProperty.call(paths, alias)) {
      const folderPaths = paths[alias]
      computedPaths.push({
        alias: alias.replace(/\/\*{1,2}(\*)?$/, ''),
        folders: folderPaths.map((folder: string) =>
          path.join(process.cwd(), folder.replace(/\/\*{1,2}(\*)?$/, ''))
        ),
      })
    }
  }

  files.forEach((file) => {
    const content = fs.readFileSync(file, 'utf-8')

    // Replace relative imports with alias
    const updatedContent = content.replace(
      /(import\s+.*?['"])(\.{1,2}\/.*?)(['"])/g,
      (fullMatch, prefix, relativePath, suffix) => {
        // Calculate the absolute path of the imported file
        const importedFilePath = path.resolve(path.dirname(file), relativePath)

        // Navigate back specified number of folders
        const backFoldersTo = countRelativePaths(relativePath)
        let currentDir = path.dirname(file)
        for (let i = 0; i < backFoldersTo; i++) {
          currentDir = path.dirname(currentDir)
        }

        // If not within the base directory, return original path
        if (!currentDir.startsWith(dir)) {
          return fullMatch
        }

        // Check if the imported file is outside ALL configured path folders
        const isOutsideAllPaths = computedPaths.every(
          (aliasPath) =>
            !aliasPath.folders.some((folderPath) =>
              importedFilePath.startsWith(folderPath)
            )
        )

        // If outside all paths, return original path
        if (isOutsideAllPaths) {
          return fullMatch
        }

        // Try to match and replace with the most specific alias
        let bestMatch: { alias: string; relativeImportPath: string } | null =
          null

        computedPaths.forEach((aliasPath) => {
          aliasPath.folders.forEach((folderPath) => {
            // Check if the imported file is within this alias's folder path
            if (importedFilePath.startsWith(folderPath)) {
              // Calculate the relative path within the alias folder
              const relativeImportPath = path.relative(
                folderPath,
                importedFilePath
              )
              const newPathCandidate = path.join(
                aliasPath.alias,
                relativeImportPath
              )

              // Choose the most specific (longest) match
              if (
                !bestMatch ||
                newPathCandidate.length > bestMatch.relativeImportPath.length
              ) {
                bestMatch = {
                  alias: aliasPath.alias,
                  relativeImportPath: newPathCandidate,
                }
              }
            }
          })
        })

        // Return the best matching path or original if no match found
        return bestMatch
          ? `${prefix}${getProp(bestMatch, 'relativeImportPath')}${suffix}`
          : fullMatch
      }
    )

    if (content !== updatedContent) {
      console.log('Updated import in:', file)
      fs.writeFileSync(file, updatedContent, 'utf-8')
    }
  })
}

function countRelativePaths(path: string) {
  // Expresión regular para buscar apariciones de ../
  const regex = /\.\.\//g
  // Usa match para encontrar todas las coincidencias
  const matches = path.match(regex)
  // Devuelve la cantidad de coincidencias o 0 si no hay ninguna
  return matches ? matches.length : 0
}

/**
 * Recursively lists files in a directory that match the specified extensions,
 * excluding certain directories or files.
 * @param {string} dir - The directory to search.
 * @param {string[]} types - The file extensions to include.
 * @param {string[]} exclude - The directories or files to exclude.
 * @returns {string[]} - An array of file paths that match the extensions.
 */
function listFilesByTypes(
  dir: string,
  types: string[],
  exclude: string[] = []
) {
  const matchedFiles: any = []

  function recursiveRead(currentDir: string) {
    const entries = fs.readdirSync(currentDir, { withFileTypes: true })
    const excludedFiles = exclude.map((item) => {
      const file = path.join(currentDir, item.trim())
      if (fs.existsSync(file)) {
        return file
      }
      return item.trim()
    })

    for (const entry of entries) {
      const fullPath = path.join(currentDir, entry.name)

      // Skip excluded directories or files
      if (excludedFiles.some((excluded) => fullPath.includes(excluded))) {
        continue
      }

      if (entry.isDirectory()) {
        recursiveRead(fullPath)
      } else if (entry.isFile()) {
        const ext = path.extname(entry.name).slice(1) // Remove the leading dot
        if (types.includes(ext)) {
          matchedFiles.push(fullPath)
        }
      }
    }
  }

  recursiveRead(dir)
  return matchedFiles
}

function getArgument(key: string, defaultValue: string = './') {
  const args = process.argv.slice(2) // Ignorar node y script
  const prefix = `${key}=`

  // Buscar el argumento que comienza con el prefix
  const arg = args.find((arg) => arg.startsWith(prefix))

  if (arg) {
    return arg.slice(prefix.length)
  } else {
    return defaultValue
  }
}

const checkPaths = (tsconfig: any) => {
  const baseUrl = getProp(tsconfig, 'compilerOptions.baseUrl')
  const paths = getProp(tsconfig, 'compilerOptions.paths')

  if (!tsconfig || !baseUrl || !paths) {
    return false
  }

  const aliasList = Object.keys(paths).filter((alias) => alias.startsWith('@/'))
  if (aliasList.length == 0) {
    return false
  }

  return true
}

const getTsConfig = () => {
  const tsconfigPath = path.resolve(process.cwd(), 'tsconfig.json')
  if (!fs.existsSync(tsconfigPath)) {
    return
  }

  const tsconfigContent = fs.readFileSync(tsconfigPath, 'utf-8')
  const parsedTsconfig = jsonc.parse(tsconfigContent)
  return parsedTsconfig
}

figlet('kora-utils', (err, data) => {
  if (err) {
    console.log('Algo salió mal...', err)
    return
  }

  init(data)
})

/**
 * Obtiene una propiedad anidada de un objeto dado un path.
 *
 * @param obj - El objeto del cual obtener la propiedad.
 * @param path - La ruta a la propiedad, separada por puntos (e.g., "a.b.c").
 * @param defaultValue - Valor predeterminado si la propiedad no existe.
 * @returns El valor de la propiedad o el valor predeterminado.
 */
function getProp<T>(
  obj: Record<string, any>,
  path: string,
  defaultValue?: T
): T | undefined {
  if (!obj || typeof path !== 'string') {
    return defaultValue
  }

  const keys = path.split('.') // Divide el path en claves
  let current = obj

  for (const key of keys) {
    if (current && typeof current === 'object' && key in current) {
      current = current[key] // Avanza al siguiente nivel del objeto
    } else {
      return defaultValue // Retorna el valor predeterminado si no existe
    }
  }

  return current as T // Retorna el valor final encontrado
}
